import { createReducer } from '@reduxjs/toolkit';

import { AuthUser } from '../../../types/reducers';
import {
    addCompanyProfile,
    addJobInDraft,
    changePassword,
    forgetPassword,
    getAnnualRevenue,
    getCompanySize,
    getIndustryType,
    getUserProfile,
    logout,
    resendEmailOtp,
    resetPassword,
    signInUser,
    signUpUser,
    verifyEmailOtp,
    verifyForgotPassword
} from './actions';

const initialState: AuthUser = {
    user: null,
    data: null,
    token: null,
};

const authReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(signUpUser.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(signInUser.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(verifyEmailOtp.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(changePassword.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(forgetPassword.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(resetPassword.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(verifyForgotPassword.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(logout.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(getAnnualRevenue.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(getIndustryType.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(getCompanySize.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(addCompanyProfile.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(getUserProfile.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(resendEmailOtp.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        })
        .addCase(addJobInDraft.fulfilled, (state, { payload }) => {
            state.data = payload?.data;
        });
});

export default authReducer;
